var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowGrowth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77908 1.66675C7.81538 1.66675 7.85185 1.66944 7.88759 1.67651C7.94436 1.68774 7.99688 1.71019 8.04601 1.73728C8.0908 1.76196 8.13389 1.79152 8.17188 1.82951C8.20949 1.86713 8.23845 1.90998 8.26302 1.95429C8.29028 2.00341 8.31242 2.0559 8.32379 2.11271C8.33102 2.14885 8.33464 2.18558 8.33464 2.2223V7.77786C8.33464 8.08468 8.08591 8.33342 7.77908 8.33342C7.47226 8.33342 7.22352 8.08468 7.22352 7.77786V3.56345L2.61632 8.17065C2.39936 8.38761 2.04769 8.38761 1.83073 8.17065C1.61377 7.9537 1.61377 7.60202 1.83073 7.38506L6.43793 2.77786H2.22352C1.9167 2.77786 1.66797 2.52913 1.66797 2.2223C1.66797 1.91548 1.9167 1.66675 2.22352 1.66675H7.77908Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowGrowth);
export default __webpack_public_path__ + "static/media/arrow-growth.6f97de975b9b473fa33bed92038dc722.svg";
export { ForwardRef as ReactComponent };